import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { RoleService } from '../services/role_service/role.service';

export const rbacGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state) => {
    const roleService: RoleService = inject(RoleService);

    const userRole = roleService.getRole();
    const allowedRoles = route.data['roles'] as string[];

    if (allowedRoles && userRole) {
        return allowedRoles.includes(userRole);
    }
    return false;
};
